module.exports = __webpack_public_path__ + "media/site/images/icons/database-design-icon-ac5b7e8925c9b71dfd262176e4468d69.svg";